module.exports = __webpack_public_path__ + "img/star.32cbfac6.svg";